import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import DataGridConfigEditor from './typeEditors/DataGridConfigEditor'
import PresentationTableConfigEditor from './typeEditors/PresentationTableConfigEditor'
import MetricConfigEditor from './typeEditors/MetricConfigEditor'
import ChartConfigEditor from './typeEditors/ChartConfigEditor'
import HierarchicalTableConfigEditor from './typeEditors/HierarchicalTableConfigEditor'
import HierarchicalGridConfigEditor from './typeEditors/HierarchicalGridConfigEditor'

const EDITOR_MAP = {
  'Data Grid': DataGridConfigEditor,
  'Presentation Table': PresentationTableConfigEditor,
  Metric: MetricConfigEditor,
  Chart: ChartConfigEditor,
  'Hierarchical Table': HierarchicalTableConfigEditor,
  'Hierarchical Grid': HierarchicalGridConfigEditor
}

function PresentationDetailPanel ({
  optionCode,
  optionData,
  allPurposes,
  onUpdateConfig
}) {
  const handleConfigUpdate = useCallback((updatedConfig) => {
    onUpdateConfig(optionCode, updatedConfig)
  }, [onUpdateConfig, optionCode])

  if (!optionCode || !optionData) {
    return (
      <div style={{
        padding: '32px',
        textAlign: 'center',
        color: 'var(--text-color-subtle)',
        paddingLeft: '32px'
      }}
      >
        <p>Select a presentation option to view and edit details</p>
      </div>
    )
  }

  const Editor = EDITOR_MAP[optionData.type] || null

  return (
    <div style={{ paddingLeft: '24px', overflowY: 'auto' }}>
      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ marginBottom: '4px' }}>{optionData.displayName}</h3>
        <div style={{ fontSize: '0.875rem', color: 'var(--text-color-subtle)' }}>
          {optionData.type} • {optionCode}
        </div>
        {optionData.description
          ? (
            <p style={{ marginTop: '8px', fontSize: '0.875rem', color: 'var(--text-color-subtle)' }}>
              {optionData.description}
            </p>
          )
          : null}
      </div>

      {Editor
        ? <Editor key={optionCode} config={optionData.config} allPurposes={allPurposes} onUpdate={handleConfigUpdate} />
        : null}
    </div>
  )
}

PresentationDetailPanel.propTypes = {
  optionCode: PropTypes.string,
  optionData: PropTypes.object,
  allPurposes: PropTypes.object.isRequired,
  onUpdateConfig: PropTypes.func.isRequired
}

export default PresentationDetailPanel
